import type { TimeSeriesChartWidget } from '@piccolohealth/pbs-common';
import { ChakraV3, ScrollArea } from '@piccolohealth/ui';
import React from 'react';
import { FaPlus } from 'react-icons/fa';

import { FormSection } from '../../../../components/forms/FormSection';
import { FormStack } from '../../../../components/forms/FormStack';
import type { UseTimeseriesChartReturn } from '../../hooks/useTimeseriesChart';
import { PhaseChangeLineAddControl } from '../phaseChange/PhaseChangeLineAddControl';
import { PhaseChangeList } from '../phaseChange/PhaseChangeList';
import { AxesControl } from './AxesControl';
import { TimeSeriesList } from './TimeSeriesList';

interface Props {
  chart: UseTimeseriesChartReturn;
  onSubmit: (value: TimeSeriesChartWidget) => void;
}

export const TimeSeriesWidgetModalSidebar = (props: Props) => {
  const { chart, onSubmit } = props;

  return (
    <ChakraV3.Stack w='390px' h='full' gap={4} flexShrink={0}>
      <ScrollArea h='full'>
        <FormStack p={4}>
          <FormSection heading='Basic details' description='Set the basic details of the chart'>
            <ChakraV3.FormField label='Chart title'>
              <ChakraV3.Input
                value={chart.widget.title}
                onChange={(e) => chart.onSetTitle(e.target.value)}
                size='sm'
                placeholder='Enter chart title'
              />
            </ChakraV3.FormField>
          </FormSection>

          <ChakraV3.Separator />

          <FormSection heading='Behaviours' description='Select the behaviours you want to view'>
            <TimeSeriesList chart={chart} />
          </FormSection>

          <ChakraV3.Separator />

          <FormSection heading='Axes' description='Set the labels for the Y axes'>
            <AxesControl chart={chart} />
          </FormSection>

          <ChakraV3.Separator />

          <FormSection heading='Phase change lines' description='Add a phase change line'>
            <PhaseChangeList chart={chart} />
            <PhaseChangeLineAddControl chart={chart} />
          </FormSection>

          <ChakraV3.Spacer />
        </FormStack>
      </ScrollArea>
      <ChakraV3.Stack px={4} pb={4}>
        <ChakraV3.Button onClick={() => onSubmit(chart.widget)} size='sm' colorPalette='brand'>
          <FaPlus />
          Save
        </ChakraV3.Button>
      </ChakraV3.Stack>
    </ChakraV3.Stack>
  );
};
